// extracted by mini-css-extract-plugin
export default {"myBtn":"Photo_myBtn__Mm3oZ","blur":"Photo_blur__qe8hz","text_no_blur":"Photo_text_no_blur__fasvm"};